// extracted by mini-css-extract-plugin
module.exports = {"tooltipButton":"TooltipButton_tooltipButton__KciKc","small":"TooltipButton_small__ImxDi"};